import { Tabs } from '@arco-design/web-react';
import type { ReactNode } from 'react';
import {
  Building2,
  LayoutDashboard,
  Receipt,
  Server,
  ShieldCheck,
  Tags,
  TrendingUp,
  Wallet,
} from 'lucide-react';
import { useTranslation } from 'react-i18next';

const TabPane = Tabs.TabPane;

export type TabKey =
  | 'executive'
  | 'temporal'
  | 'supplier'
  | 'category'
  | 'inventory'
  | 'account'
  | 'transactions'
  | 'compliance';

const ICONS: Record<TabKey, typeof LayoutDashboard> = {
  executive: LayoutDashboard,
  temporal: TrendingUp,
  supplier: Building2,
  category: Tags,
  inventory: Server,
  account: Wallet,
  transactions: Receipt,
  compliance: ShieldCheck,
};

const TAB_ORDER: TabKey[] = [
  'executive',
  'temporal',
  'supplier',
  'category',
  'inventory',
  'account',
  'transactions',
  'compliance',
];

interface TabsNavProps {
  activeKey: TabKey;
  onChange: (key: TabKey) => void;
  panels: Record<TabKey, ReactNode>;
}

export function TabsNav({ activeKey, onChange, panels }: TabsNavProps) {
  const { t } = useTranslation();

  return (
    <Tabs
      activeTab={activeKey}
      onChange={(key) => onChange(key as TabKey)}
      type="line"
      size="large"
      className="aiobi-tabs"
    >
      {TAB_ORDER.map((key) => {
        const Icon = ICONS[key];
        return (
          <TabPane
            key={key}
            title={
              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 6,
                }}
              >
                <Icon size={16} />
                {t(`tabs.${key}`)}
              </span>
            }
          >
            {panels[key]}
          </TabPane>
        );
      })}
    </Tabs>
  );
}
